import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  Container,
  CssBaseline,
  Box,
} from "@mui/material";

export default function BillingShippingComponent(props) {
  const { t } = useTranslation();
  const [useBillingAddress, setUseBillingAddress] = useState(Boolean());
  const [data, setData] = useState({
    firstName: String(),
    lastName: String(),
    address1: String(),
    address2: String(),
    country: String(),
    city: String(),
    stateProvince: String(),
    zipCode: String(),
  });

  useEffect(() => {
    if (props.address) {
      setData(props.address);
    }
  });

  const handleTextChange = (e) => {
    const value = e.target.value;

    setData({
      ...data,
      [e.target.name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    props.onComplete("billingAddress", data);
  };

  useEffect(() => {
    if (useBillingAddress) {
      setData(props.fillWith);
    }
  }, [setData, props.fillWith, useBillingAddress]);

  return (
    <Container component="main">
      <CssBaseline />
      <Box
        sx={{
          m: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">{"Dirección de facturación"}</Typography>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useBillingAddress}
                    onChange={() => setUseBillingAddress(!useBillingAddress)}
                  />
                }
                label={t("Usar dirección de envio")}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="firstName"
                id="firstName"
                label={t("firtsName")}
                value={data.firstName}
                onChange={handleTextChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="lastName"
                id="lastName"
                value={data.lastName}
                label={t("lastName")}
                onChange={handleTextChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                name="address1"
                id="address1"
                value={data.address1}
                label={t("address1")}
                onChange={handleTextChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="address2"
                id="address2"
                value={data.address2}
                label={t("address2")}
                onChange={handleTextChange}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="country"
                id="country"
                value={data.country}
                label={t("country")}
                onChange={handleTextChange}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="city"
                id="city"
                value={data.city}
                label={t("city")}
                onChange={handleTextChange}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="stateProvince"
                id="stateProvince"
                value={data.stateProvince}
                label={t("stateProvince")}
                onChange={handleTextChange}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                fullWidth
                name="zipCode"
                id="zipCode"
                value={data.zipCode}
                label={t("zipCode")}
                onChange={handleTextChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth type="submit" variant="contained">
                {t("next")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}
